import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "background-size"
    }}>{`background-size`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`  UXP v3.0`}</p>
    <p>{`Determines the size of the background content. Also supports `}<inlineCode parentName="p">{`cover`}</inlineCode>{` and `}<inlineCode parentName="p">{`contain`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en/docs/Web/CSS/background-size"
      }}>{`https://developer.mozilla.org/en/docs/Web/CSS/background-size`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      